/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


// (function() {
  // Add custom code below this line
async function applyDiscountCode(discountCode){
  document.cookie = `discount_code=${discountCode}; path=/`;
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      updates: {"42037573255239": 1},
      discount: discountCode,
    }),
  })
    .then((res) => res.json())
    .then((cart) => {
      console.log("Discount applied:", cart);
    })
    .catch((error) => {
      console.error("Error applying discount:", error);
    });
}
async function clearDiscounts(){
  document.cookie = "discount_code=;expires=Thu, 01 Jan 1970 00:00:00 UTC;";
  await fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      updates: {"42037573255239": 0},
      discount: "",
    }),
  })
  .then((res) => res.json())
  .then((cart) => {
    console.log("Discount removed:", cart);
    
  })
  .catch((error) => {
    console.error("Error removing discount:", error);
  });
}

async function validateMembershipCode() {
  console.log("Validating Membership Code");
  await fetch("/cart.js")
    .then((res) => res.json())
    .then(async (data) => {
      const discountExists = data.discount_codes.some(
        (item) => item.code.toUpperCase() === "MEMBER15" || item.code.toUpperCase() === "WELCOME40"
      );
      // 42037573255239
      const membershipProductIDs = [42037384282183, 42037511651399];
      const hasMembershipProduct = data.items.some((item) =>
        membershipProductIDs.includes(item.variant_id)
      );
      const totalAmount = (data.original_total_price - 120000) / 100;

      const hasMembershipGift = data.items.some((item) =>
        item.variant_id === 42037573255239
      );
      if(hasMembershipProduct && document.querySelector(".membership__upsell")){
        document.querySelector(".membership__upsell").style.display = "none";
      }

      // Remove the discount if membership product is not in cart
      if (discountExists && !hasMembershipProduct) {
        document.cookie =
          "discount_code=;expires=Thu, 01 Jan 1970 00:00:00 UTC;";
         await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            updates: {"42037573255239": 0},
            discount: "",
          }),
        })
          .then((res) => res.json())
          .then((cart) => {
            console.log("Discount removed:", cart);
            // window.location.reload();
          })
          .catch((error) => {
            console.error("Error removing discount:", error);
          });
      }

      // CHange the discount code if is above 8K
      if(hasMembershipProduct ){
        console.log("hasMembershipProduct"+hasMembershipProduct)
        const is40PercentOff = data.discount_codes.some(
        (item) => item.code.toUpperCase() === "WELCOME40"
      );
      console.log("is40PercentOff"+is40PercentOff)
        if(totalAmount > 8000 && !is40PercentOff){
          // await clearDiscounts();
          await applyDiscountCode("WELCOME40");
          // document.dispatchEvent(
          //   new CustomEvent("theme:cart:refresh", {
          //     detail: {
          //       target: "coupon_validate",
          //     },
          //     bubbles: true,
          //   })
          // );
        }else{
          // await clearDiscounts();
          await applyDiscountCode("MEMBER15");
          // document.dispatchEvent(
          //   new CustomEvent("theme:cart:refresh", {
          //     detail: {
          //       target: "coupon_validate",
          //     },
          //     bubbles: true,
          //   })
          // );
        }
        

      }

      // Add membership gift if Membership Product Exists
      if(!hasMembershipGift && hasMembershipProduct){
         await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            "items": [{id: 42037573255239, quantity: 1}],
          }),
        })
          .then((res) => res.json())
          .then((cart) => {
            console.log("Discount removed:", cart);
            // window.location.reload();
          })
          .catch((error) => {
            console.error("Error removing discount:", error);
          });
      }

      // Apply the discount if the membership product is in the cart
      if (!discountExists && hasMembershipProduct) {
        document.cookie = "discount_code=MEMBER15; path=/";
        fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            updates: {"42037573255239": 1},
            discount: "MEMBER15",
          }),
        })
          .then((res) => res.json())
          .then((cart) => {
            console.log("Discount applied:", cart);
            // window.location.reload();
          })
          .catch((error) => {
            console.error("Error applying discount:", error);
          });
      }
    });
    
    
  }
  // validateMembershipCode();
  document.addEventListener("theme:cart:change",validateMembershipCode);
  // window.addEventListener("theme:cart:add", validateMembershipCode);
  // window.addEventListener("theme:cart:remove", validateMembershipCode);
  // document.addEventListener("theme:cart:toggle", validateMembershipCode);
  // document.addEventListener("theme:cart-drawer:open", validateMembershipCode);
  // document.addEventListener("theme:cart-drawer:close", validateMembershipCode);


 

  function addFreeGift() {
  console.log("Checking cart Gifts ");
    // --- CONFIGURATION ---
    const VARIANT_ID_X = 41918163877959; // <--- **REPLACE with your actual Variant ID X**
    const VARIANT_ID_Y = 41917950427207; // <--- **REPLACE with your actual Variant ID Y**
    const VARIANT_Y_QUANTITY = 1;

    // 1. Get current cart contents
    fetch('/cart.json')
        .then(response => response.json())
        .then(cart => {
            let hasVariantX = false;
            let hasVariantY = false;

            // Check if Variant X and/or Variant Y exist in the cart
            cart.items.forEach(item => {
                if (item.variant_id === VARIANT_ID_X) {
                    hasVariantX = true;
                }
                if (item.variant_id === VARIANT_ID_Y) {
                    hasVariantY = true;
                }
            });

            // 2. Apply the condition: Variant X exists AND Variant Y does not exist
            if (hasVariantX && !hasVariantY) {
                console.log(`Variant X (${VARIANT_ID_X}) found, but Variant Y (${VARIANT_ID_Y}) is missing. Adding Variant Y.`);
                
                // 3. Add Variant Y to the cart
                const formData = {
                    'items': [{
                        'id': VARIANT_ID_Y,
                        'quantity': VARIANT_Y_QUANTITY
                    }]
                };

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                })
                .then(response => response.json())
                .then(data => {
                    console.log('Variant Y successfully added to cart:', data);
                    
                    // 4. Update the cart interface to reflect the change
                    // This step is highly theme-dependent. 
                    // You'll likely need to call your theme's function 
                    // to refresh the cart drawer/count (e.g., Shopify.
                    // fire('cart:change') or a specific theme update function).
                    // For a simple theme, a page refresh might be needed, 
                    // though this is not ideal for UX.
                    
                    // Simple example of triggering a general event (theme-dependent)
                    document.dispatchEvent(new CustomEvent('cart:add', { detail: data }));
                    document.dispatchEvent(
                      new CustomEvent("theme:cart:refresh", {
                        detail: {
                          target: "coupon_validate",
                        },
                        bubbles: true,
                      })
                    );

                    
                })
                .catch((error) => {
                    console.error('Error adding Variant Y:', error);
                });
            } else {
                console.log('Cart check complete. No action needed.');
            }
        })
        .catch(error => {
            console.error('Error fetching cart:', error);
        });
}

  
  // addFreeGift();
  
  // document.addEventListener("theme:cart:change", addFreeGift);
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
// })();






// const MEMBERSHIP_VARIANTS = [42037384282183, 42037511651399];
// const GIFT_VARIANT = 42037573255239;

// async function enforceMembershipRequirement() {
//   try {
//     const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
//     const hasMembershipProduct = cart.items.some(item => MEMBERSHIP_VARIANTS.includes(item.variant_id));
//     if (!hasMembershipProduct) {
//       document.cookie = 'discount_code=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/';
//       await fetch('/cart/update.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ updates: { [GIFT_VARIANT]: 0 }, discount: '' })
//       });
//     }
//   } catch (err) {
//     console.error('Membership guard failed', err);
//   }
// }

// document.addEventListener('DOMContentLoaded', enforceMembershipRequirement);
// const nativeFetch = window.fetch;
// window.fetch = async function patchedFetch(resource, config) {
//   const response = await nativeFetch(resource, config);
//   const url = typeof resource === 'string' ? resource : resource.url;

//   if (url.includes('/cart')) {
//     enforceMembershipRequirement();
//   }
//   return response;
// };

const MEMBERSHIP_VARIANTS = [42037384282183, 42037511651399];
const GIFT_VARIANT = 42037573255239;

// (Keep the core enforceMembershipRequirement function as is)
async function enforceMembershipRequirement() {
  try {
    const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
    // ... (rest of the logic remains the same)
    const hasMembershipProduct = cart.items.some(item => MEMBERSHIP_VARIANTS.includes(item.variant_id));
    if (!hasMembershipProduct) {
      document.cookie = 'discount_code=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/';
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [GIFT_VARIANT]: 0 }, discount: '' })
      });
    }
  } catch (err) {
    console.error('Membership guard failed', err);
  }
}

// 1. Keep the initial DOMContentLoaded check (runs once on page load)
document.addEventListener('DOMContentLoaded', enforceMembershipRequirement);

// 2. Patch fetch, but add logic to restrict the check
const nativeFetch = window.fetch;
window.fetch = async function patchedFetch(resource, config) {
  const url = typeof resource === 'string' ? resource : resource.url;
  const method = config?.method?.toUpperCase() || 'GET';

  const response = await nativeFetch(resource, config);

  // **CRITICAL CHANGE HERE:**
  // ONLY run the check if the request was a POST to a cart modification endpoint.
  if (method === 'POST' && url.includes('/cart/update.js')) {
    // Specifically check for /cart/add.js, /cart/change.js, /cart/update.js
    enforceMembershipRequirement();
  }

  return response;
};